import { Badge } from 'foundations-components/transitional/components/Badge';
import { H1 } from 'foundations-components/transitional/components/H1';
import styled, { theme } from 'academy-common-lib/utils/Styling';
// @ts-expect-error img
import blobsImageUrl from 'bender-url!../../../../images/header-blobs.svg';
import ErrorBoundary from '../../../components/ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Header = styled.header.withConfig({
  displayName: "PublicPageHeader__Header",
  componentId: "axa9aa-0"
})(["background:", ";background:url(", ") center center no-repeat,linear-gradient( to right,", ",", " );background-size:auto 100%;color:", ";text-align:center;padding:40px 16px;"], theme.colors.CALYPSO, blobsImageUrl, theme.colors.CALYPSO_DARK, theme.colors.CALYPSO, theme.colors.OLAF);
const HeaderContainer = styled.div.withConfig({
  displayName: "PublicPageHeader__HeaderContainer",
  componentId: "axa9aa-1"
})(["max-width:", ";margin:0 auto;position:relative;"], theme.sizes.GRID_BREAKPOINT_MEDIUM);
const Description = styled.div.withConfig({
  displayName: "PublicPageHeader__Description",
  componentId: "axa9aa-2"
})(["font-size:16px;"]);
const RightContent = styled.div.withConfig({
  displayName: "PublicPageHeader__RightContent",
  componentId: "axa9aa-3"
})(["position:absolute;max-width:160px;width:fit-content;right:-220px;margin:0 auto;bottom:0;@media (max-width:", "){position:static;}"], theme.sizes.GRID_BREAKPOINT_EXTRA_LARGE);
const PublicPageHeader = ({
  badgeText,
  heading,
  description,
  rightContent,
  children
}) => {
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    children: /*#__PURE__*/_jsx(Header, {
      children: /*#__PURE__*/_jsxs(HeaderContainer, {
        children: [badgeText && /*#__PURE__*/_jsx(Badge, {
          marginBlockEnd: "600",
          use: "thunderdome",
          children: badgeText
        }), heading && /*#__PURE__*/_jsx(H1, {
          children: heading
        }), description && /*#__PURE__*/_jsx(Description, {
          className: "m-bottom-6",
          children: description
        }), children, rightContent && /*#__PURE__*/_jsx(RightContent, {
          children: rightContent
        })]
      })
    })
  });
};
export default PublicPageHeader;